//
export default [
    {
        field: 'rut',
        type: 'rut',
        maxLength: 12,
        value: '',
        vuetifyProps: {
            textFieldProps: {
                label: 'RUT',
                readonly: true,
                disabled: true,
            },
        },
    },
    {
        field: 'alias_name',
        type: 'readonly',
        value: '',
        vuetifyProps: {
            label: 'Nombre Fantasía',
        },
    },
    {
        field: 'business_name',
        type: 'readonly',
        maxLength: 100,
        value: '',
        vuetifyProps: {
            label: 'Razón social',
        },
    },
    {
        field: 'coreBusiness',
        type: 'readonly',
        maxLength: 100,
        value: '',
        vuetifyProps: {
            label: 'Giro',
        },
    },
    // {
    //     field: 'phone',
    //     type: 'text',
    //     maxLength: 100,
    //     value: '',
    //     vuetifyProps: {
    //         label: 'Telefono',
    //     },
    // },
    // {
    //     field: 'email',
    //     type: 'text',
    //     maxLength: 100,
    //     value: '',
    //     vuetifyProps: {
    //         label: 'Correo Electrónico',
    //     },
    // },
    
]
